import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import BsTags from '../icons/BsTags';
import { func, string } from 'prop-types';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

export default function SearchResultsItemCollection({ title, handle, onClick = () => { }, minPrice, maxPrice, query }) {
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const searchParams = new URLSearchParams({
        ...!!minPrice && { minPrice },
        ...!!maxPrice && { maxPrice },
    });

    const handleMatched = (handle, query) => {
        return query.replace(/[^0-9-]/g, '') === handle.replace(/[^0-9-]/g, '');
    };

    const highlight = useCallback(word => {
        if (!query) {
            return false;
        }

        return query.toLowerCase().split(' ').some(element => {
            if (element === '') {
                return false;
            }

            return word.toLowerCase().includes(element);
        });
    }, [query]);

    return (<li>
        <Link
            onClick={onClick}
            className={'search--results-item search--results-item-link'}
            to={`${collectionPath[0].pathBeforeParams}/${handle}?${searchParams.toString()}`}>
            <span
                className={'me-2'}><BsTags
                    size={'25px'} /></span>
            {title?.length > 0 && (<p
                className={`search--results-item-title ${handleMatched(handle,query) ? 'fw-bold' : ''}`}>{title.split(' ').map((word, i) => {
                    return (
                        <>
                            <span
                                className={highlight(word) ? 'highlight' : ''}
                                key={i}
                            >
                                {word}
                            </span>{' '}
                        </>
                    );
                })}</p>)}
        </Link>
    </li>);
}

SearchResultsItemCollection.propTypes = {
    title: string,
    handle: string,
    onClick: func,
    minPrice: string,
    maxPrice: string,
    query: string
};